import { CurrencyAmount } from '@kodiak-finance/sdk-core'
import REWARD_VAULT_ABI from 'abis/RewardVault.json'
import { REFETCH_POLICY_FAST } from 'config/RefetchPolicies'
import { useConnection } from 'hooks/useConnection'
import useNativeCurrency from 'lib/hooks/useNativeCurrency'
import { useMemo } from 'react'
import { Abi, Address } from 'viem'
import { useReadContract } from 'wagmi'

import { useToken } from './Tokens'
import { YEAR } from './useKodiakFarm'
import { useReadContractMultiple } from './useReadContractMultiple'
import { useApiTokenValue, useGetTokenPrice, useTokenValue } from './useTokenPrice'

/**
 * Hook to fetch data from a RewardVault contract
 * @param vaultAddress Address of the RewardVault contract
 * @param accountAddress Optional account to fetch data for (defaults to connected account)
 * @param fallbackRewardPrice Optional fallback price for reward token (defaults to 1)
 * @returns Object containing RewardVault data and loading state
 */

// export const useRewardAddressByIsland = (island?: string) => {
//   const { chainId } = useConnection()
//   const farmMap = useMemo(() => (chainId ? ISLANDS_TO_REWARD_VAULT[chainId] : {}), [chainId])
//   return useMemo(() => (island && farmMap ? farmMap[island.toLowerCase()] : undefined), [island, farmMap])
// }

// export const useRewardVaultData = (
//   vaultAddress: string | null,
//   accountAddress?: string,
//   fallbackRewardPrice = 1 // Default fallback price
// ) => {
//   const { account: connectedAccount } = useConnection()
//   const account = useMemo(() => accountAddress || connectedAccount, [accountAddress, connectedAccount])

//   // Stabilize vault address reference
//   const stableVaultAddress = useMemo(() => vaultAddress, [vaultAddress])

//   // Build contracts array for batch reading
//   const contracts = useMemo(() => {
//     if (!stableVaultAddress) return []
//     const basicContracts = [
//       {
//         address: stableVaultAddress as Address,
//         abi: REWARD_VAULT_ABI as Abi,
//         functionName: 'stakeToken',
//       },
//       {
//         address: stableVaultAddress as Address,
//         abi: REWARD_VAULT_ABI as Abi,
//         functionName: 'rewardToken',
//       },
//       {
//         address: stableVaultAddress as Address,
//         abi: REWARD_VAULT_ABI as Abi,
//         functionName: 'rewardRate',
//       },
//       {
//         address: stableVaultAddress as Address,
//         abi: REWARD_VAULT_ABI as Abi,
//         functionName: 'rewardsDuration',
//       },
//       {
//         address: stableVaultAddress as Address,
//         abi: REWARD_VAULT_ABI as Abi,
//         functionName: 'totalSupply',
//       },
//       {
//         address: stableVaultAddress as Address,
//         abi: REWARD_VAULT_ABI as Abi,
//         functionName: 'periodFinish',
//       },
//     ]

//     const accountContracts = account
//       ? [
//           {
//             address: stableVaultAddress as Address,
//             abi: REWARD_VAULT_ABI as Abi,
//             functionName: 'balanceOf',
//             args: [account as Address],
//           },
//           {
//             address: stableVaultAddress as Address,
//             abi: REWARD_VAULT_ABI as Abi,
//             functionName: 'earned',
//             args: [account as Address],
//           },
//           {
//             address: stableVaultAddress as Address,
//             abi: REWARD_VAULT_ABI as Abi,
//             functionName: 'getTotalDelegateStaked',
//             args: [account as Address],
//           },
//         ]
//       : []

//     return [...basicContracts, ...accountContracts]
//   }, [stableVaultAddress, account])

//   const { data: results, isLoading: isLoadingBatch } = useReadContractMultiple({
//     contracts,
//     query: {
//       ...WAGMI_REFETCH_POLICY_REALTIME,
//       enabled: contracts.length > 0,
//     },
//   })

//   const stakeTokenResult = useMemo(() => {
//     return {
//       result: results?.[0]?.result !== undefined ? [results[0].result] : undefined,
//       loading: isLoadingBatch,
//       error: results?.[0]?.status === 'failure',
//     }
//   }, [results, isLoadingBatch])
//   const rewardTokenResult = useMemo(() => {
//     return {
//       result: results?.[1]?.result !== undefined ? [results[1].result] : undefined,
//       loading: isLoadingBatch,
//       error: results?.[1]?.status === 'failure',
//     }
//   }, [results, isLoadingBatch])
//   const rewardRateResult = useMemo(() => {
//     return {
//       result: results?.[2]?.result !== undefined ? [results[2].result] : undefined,
//       loading: isLoadingBatch,
//       error: results?.[2]?.status === 'failure',
//     }
//   }, [results, isLoadingBatch])
//   const rewardsDurationResult = useMemo(() => {
//     return {
//       result: results?.[3]?.result !== undefined ? [results[3].result] : undefined,
//       loading: isLoadingBatch,
//       error: results?.[3]?.status === 'failure',
//     }
//   }, [results, isLoadingBatch])
//   const totalSupplyResult = useMemo(() => {
//     return {
//       result: results?.[4]?.result !== undefined ? [results[4].result] : undefined,
//       loading: isLoadingBatch,
//       error: results?.[4]?.status === 'failure',
//     }
//   }, [results, isLoadingBatch])
//   const periodFinishResult = useMemo(() => {
//     return {
//       result: results?.[5]?.result !== undefined ? [results[5].result] : undefined,
//       loading: isLoadingBatch,
//       error: results?.[5]?.status === 'failure',
//     }
//   }, [results, isLoadingBatch])

//   const balanceOfResult = useMemo(() => {
//     return {
//       result: results?.[6]?.result !== undefined ? [results[6].result] : undefined,
//       loading: isLoadingBatch,
//       error: results?.[6]?.status === 'failure',
//     }
//   }, [results, isLoadingBatch])

//   const earnedResult = useMemo(() => {
//     return {
//       result: results?.[7]?.result !== undefined ? [results[7].result] : undefined,
//       loading: isLoadingBatch,
//       error: results?.[7]?.status === 'failure',
//     }
//   }, [results, isLoadingBatch])

//   const delegateStakedResult = useMemo(() => {
//     return {
//       result: results?.[8]?.result !== undefined ? [results[8].result] : undefined,
//       loading: isLoadingBatch,
//       error: results?.[8]?.status === 'failure',
//     }
//   }, [results, isLoadingBatch])

//   // Determine loading state
//   const isLoading = useMemo(() => {
//     const basicCalls = [
//       stakeTokenResult,
//       rewardTokenResult,
//       rewardRateResult,
//       rewardsDurationResult,
//       totalSupplyResult,
//       periodFinishResult,
//     ]

//     const accountCalls = account ? [balanceOfResult, earnedResult, delegateStakedResult] : []

//     return [...basicCalls, ...accountCalls].some((result) => result.loading)
//   }, [
//     stakeTokenResult,
//     rewardTokenResult,
//     rewardRateResult,
//     rewardsDurationResult,
//     totalSupplyResult,
//     periodFinishResult,
//     balanceOfResult,
//     earnedResult,
//     delegateStakedResult,
//     account,
//   ])

//   // Determine error state
//   const hasError = useMemo(() => {
//     const basicCalls = [
//       stakeTokenResult,
//       rewardTokenResult,
//       rewardRateResult,
//       rewardsDurationResult,
//       totalSupplyResult,
//       periodFinishResult,
//     ]

//     const accountCalls = account ? [balanceOfResult, earnedResult, delegateStakedResult] : []

//     return [...basicCalls, ...accountCalls].some((result) => !!result.error)
//   }, [
//     stakeTokenResult,
//     rewardTokenResult,
//     rewardRateResult,
//     rewardsDurationResult,
//     totalSupplyResult,
//     periodFinishResult,
//     balanceOfResult,
//     earnedResult,
//     delegateStakedResult,
//     account,
//   ])

//   // Get token objects
//   const stakeToken = useToken(stakeTokenResult.result?.[0] as string | undefined)
//   const rewardToken = useToken(rewardTokenResult.result?.[0] as string | undefined)

//   // Create CurrencyAmount objects with proper error handling
//   const userStakedAmount = useMemo(() => {
//     if (!stakeToken || !balanceOfResult.result || balanceOfResult.error) return undefined

//     try {
//       const balance = balanceOfResult.result[0]
//       return CurrencyAmount.fromRawAmount(stakeToken, balance.toString())
//     } catch (e) {
//       console.error('Error creating userStakedAmount:', e)
//       return undefined
//     }
//   }, [stakeToken, balanceOfResult])

//   const delegateStakedAmount = useMemo(() => {
//     if (!stakeToken || !delegateStakedResult.result || delegateStakedResult.error) return undefined

//     try {
//       const delegateStaked = delegateStakedResult.result[0]
//       return CurrencyAmount.fromRawAmount(stakeToken, delegateStaked.toString())
//     } catch (e) {
//       console.error('Error creating delegateStakedAmount:', e)
//       return undefined
//     }
//   }, [stakeToken, delegateStakedResult])

//   const userSelfStakedAmount = useMemo(() => {
//     if (!userStakedAmount || !delegateStakedAmount || !stakeToken) return undefined

//     try {
//       const selfStaked = userStakedAmount.subtract(delegateStakedAmount)
//       return selfStaked.greaterThan('0') ? selfStaked : CurrencyAmount.fromRawAmount(stakeToken, '0')
//     } catch (e) {
//       console.error('Error creating userSelfStakedAmount:', e)
//       return CurrencyAmount.fromRawAmount(stakeToken, '0')
//     }
//   }, [userStakedAmount, delegateStakedAmount, stakeToken])

//   const totalStaked = useMemo(() => {
//     if (!stakeToken || !totalSupplyResult.result || totalSupplyResult.error) return undefined

//     try {
//       const totalSupply = totalSupplyResult.result[0]
//       return CurrencyAmount.fromRawAmount(stakeToken, totalSupply.toString())
//     } catch (e) {
//       console.error('Error creating totalStaked:', e)
//       return undefined
//     }
//   }, [stakeToken, totalSupplyResult])

//   const rewardAmount = useMemo(() => {
//     if (!rewardToken || !earnedResult.result || earnedResult.error) return undefined

//     try {
//       const earned = earnedResult.result[0]
//       return CurrencyAmount.fromRawAmount(rewardToken, earned.toString())
//     } catch (e) {
//       console.error('Error creating rewardAmount:', e)
//       return undefined
//     }
//   }, [rewardToken, earnedResult])

//   // Calculate yearly reward amount
//   const yearlyRewardAmount = useMemo(() => {
//     if (!rewardToken || !rewardRateResult.result || rewardRateResult.error) return undefined

//     try {
//       const rewardRate = rewardRateResult.result[0] as bigint
//       const yearlyReward = rewardRate * BigInt(secondsInYear)

//       return CurrencyAmount.fromRawAmount(rewardToken, yearlyReward.toString())
//     } catch (e) {
//       console.error('Error calculating yearlyRewardAmount:', e)
//       return undefined
//     }
//   }, [rewardToken, rewardRateResult])

//   // Get USD values - these need to be called at the top level, not conditionally
//   const userStakedUSD = useTokenValue(userStakedAmount)
//   const totalStakedUSD = useTokenValue(totalStaked)
//   const rewardAmountUSD = useTokenValue(rewardAmount)
//   const subgraphYearlyRewardUSD = useTokenValue(yearlyRewardAmount)

//   // Calculate yearlyRewardUSD with fallback - now we can use useMemo correctly
//   const yearlyRewardUSD = useMemo(() => {
//     // If subgraph has a value, use it
//     if (subgraphYearlyRewardUSD !== null) {
//       return subgraphYearlyRewardUSD
//     }

//     // If no subgraph value but we have yearly reward amount, use fallback price
//     if (yearlyRewardAmount) {
//       try {
//         // Convert to decimal value using token decimals and multiply by fallback price
//         const decimals = yearlyRewardAmount.currency.decimals
//         const rawAmount = yearlyRewardAmount.quotient.toString()
//         const decimalValue = Number(rawAmount) / 10 ** decimals

//         const fallbackValue = decimalValue * fallbackRewardPrice

//         return fallbackValue
//       } catch (e) {
//         console.error('Error calculating fallback yearlyRewardUSD:', e)
//       }
//     }

//     return null
//   }, [subgraphYearlyRewardUSD, yearlyRewardAmount, fallbackRewardPrice])

//   // Calculate APR
//   const apr = useMemo(() => {
//     if (yearlyRewardUSD === null || totalStakedUSD === null || totalStakedUSD === 0) {
//       return null
//     }
//     const calculatedApr = (yearlyRewardUSD / totalStakedUSD) * 100
//     return calculatedApr
//   }, [yearlyRewardUSD, totalStakedUSD])

//   // Format the result data
//   const data = useMemo(() => {
//     if (!stakeToken) return undefined

//     // Create a position object if user has staked tokens
//     const positions =
//       userStakedAmount && !userStakedAmount.equalTo('0')
//         ? [
//             {
//               liquidity: userStakedAmount,
//             },
//           ]
//         : []

//     const periodFinish = periodFinishResult.result?.[0]
//       ? new Date(Number(periodFinishResult.result[0]) * 1000)
//       : undefined

//     const safeRewardAmount = rewardAmount || (rewardToken ? CurrencyAmount.fromRawAmount(rewardToken, '0') : undefined)

//     return {
//       totalStaked,
//       totalStakedUSD,
//       positions,
//       stakeToken,
//       rewardToken,
//       userStaked: userStakedAmount,
//       userStakedUSD,
//       selfStaked: userSelfStakedAmount,
//       delegateStaked: delegateStakedAmount,
//       earned: safeRewardAmount,
//       earnedUSD: rewardAmountUSD,
//       periodFinish,
//     }
//   }, [
//     stakeToken,
//     userStakedAmount,
//     totalStaked,
//     totalStakedUSD,
//     userSelfStakedAmount,
//     delegateStakedAmount,
//     rewardAmount,
//     rewardAmountUSD,
//     periodFinishResult.result,
//     rewardToken,
//     userStakedUSD,
//   ])

//   return {
//     isLoading,
//     error: hasError,
//     data,
//     tvl: totalStakedUSD,
//     apr,
//     yearlyRewardUSD,
//     yearlyRewardAmount: yearlyRewardAmount?.toExact ? yearlyRewardAmount.toExact() : undefined,
//     subgraphYearlyRewardUSD,
//   }
// }

/**
 * Hook to fetch a RewardVault by address
 * @param vaultAddress Address of the RewardVault contract
 * @returns RewardVault contract instance or null
 */
export const useRewardVaultByAddress = (vaultAddress?: string) => {
  return useMemo(() => {
    if (!vaultAddress) return null
    return vaultAddress
  }, [vaultAddress])
}

/**
 * Hook to fetch basic information about a reward vault
 */
export const useRewardVaultBasicInfo = (vaultAddress?: Address) => {
  const contracts = useMemo(() => {
    if (!vaultAddress) return []
    return [
      {
        address: vaultAddress,
        abi: REWARD_VAULT_ABI as Abi,
        functionName: 'stakeToken',
      },
      {
        address: vaultAddress,
        abi: REWARD_VAULT_ABI as Abi,
        functionName: 'rewardToken',
      },
      {
        address: vaultAddress,
        abi: REWARD_VAULT_ABI as Abi,
        functionName: 'rewardsDuration',
      },
      {
        address: vaultAddress,
        abi: REWARD_VAULT_ABI as Abi,
        functionName: 'periodFinish',
      },
      {
        address: vaultAddress,
        abi: REWARD_VAULT_ABI as Abi,
        functionName: 'rewardRate',
      },
    ]
  }, [vaultAddress])

  const { data: results, isLoading: isLoadingBatch } = useReadContractMultiple({
    contracts,
    query: {
      enabled: contracts.length > 0,
    },
  })

  const stakeTokenResult = useMemo(() => {
    return {
      result: results?.[0]?.result !== undefined ? [results[0].result] : undefined,
      loading: isLoadingBatch,
      error: results?.[0]?.status === 'failure',
    }
  }, [results, isLoadingBatch])
  const rewardTokenResult = useMemo(() => {
    return {
      result: results?.[1]?.result !== undefined ? [results[1].result] : undefined,
      loading: isLoadingBatch,
      error: results?.[1]?.status === 'failure',
    }
  }, [results, isLoadingBatch])
  const rewardsDurationResult = useMemo(() => {
    return {
      result: results?.[2]?.result !== undefined ? [results[2].result] : undefined,
      loading: isLoadingBatch,
      error: results?.[2]?.status === 'failure',
    }
  }, [results, isLoadingBatch])
  const periodFinishResult = useMemo(() => {
    return {
      result: results?.[3]?.result !== undefined ? [results[3].result] : undefined,
      loading: isLoadingBatch,
      error: results?.[3]?.status === 'failure',
    }
  }, [results, isLoadingBatch])
  const rewardRateResult = useMemo(() => {
    return {
      result: results?.[4]?.result !== undefined ? [results[4].result] : undefined,
      loading: isLoadingBatch,
      error: results?.[4]?.status === 'failure',
    }
  }, [results, isLoadingBatch])

  // Get token objects
  const stakingToken = stakeTokenResult.result?.[0] as string
  const rewardRate = rewardRateResult.result?.[0] ? Number(rewardRateResult.result[0]) : 0
  const stakeToken = useToken(stakingToken)
  const rewardToken = useToken(rewardTokenResult.result?.[0] as string)

  // Determine loading state
  const isLoading = useMemo(() => {
    return [stakeTokenResult, rewardTokenResult, rewardsDurationResult, periodFinishResult, rewardRateResult].some(
      (result) => result.loading
    )
  }, [stakeTokenResult, rewardTokenResult, rewardsDurationResult, periodFinishResult, rewardRateResult])

  // Determine error state
  const hasError = useMemo(() => {
    return [stakeTokenResult, rewardTokenResult, rewardsDurationResult, periodFinishResult, rewardRateResult].some(
      (result) => !!result.error
    )
  }, [stakeTokenResult, rewardTokenResult, rewardsDurationResult, periodFinishResult, rewardRateResult])

  const data = useMemo(() => {
    const periodFinish = periodFinishResult.result?.[0]
      ? new Date(Number(periodFinishResult.result[0]) * 1000)
      : undefined

    const rewardsDuration = rewardsDurationResult.result?.[0] ? Number(rewardsDurationResult.result[0]) : 0

    return {
      stakeToken,
      stakingToken,
      rewardToken,
      rewardRate,
      periodFinish,
      rewardsDuration,
      vaultAddress,
    }
  }, [
    stakeToken,
    stakingToken,
    rewardToken,
    rewardRate,
    vaultAddress,
    periodFinishResult.result,
    rewardsDurationResult.result,
  ])

  return {
    isLoading,
    error: hasError,
    data,
  }
}

/**
 * Hook to fetch total supply and TVL information
 */
export const useRewardVaultTVL = (vaultAddress?: Address) => {
  const { data: basicInfo } = useRewardVaultBasicInfo(vaultAddress)

  const {
    data: totalSupplyResult,
    isLoading,
    error,
  } = useReadContract({
    address: vaultAddress,
    abi: REWARD_VAULT_ABI as Abi,
    functionName: 'totalSupply',
    query: {
      enabled: !!vaultAddress,
    },
  })

  const hasError = !!error

  // Create CurrencyAmount for total staked
  const totalStaked = useMemo(() => {
    if (!basicInfo?.stakeToken || !totalSupplyResult) return undefined

    try {
      return CurrencyAmount.fromRawAmount(basicInfo.stakeToken, totalSupplyResult.toString())
    } catch (e) {
      console.error('Error creating totalStaked:', e)
      return undefined
    }
  }, [basicInfo?.stakeToken, totalSupplyResult])

  // Get USD value of total staked
  const totalStakedUSD = useTokenValue(totalStaked)

  return {
    isLoading,
    error: hasError,
    totalStaked,
    value: totalStakedUSD,
  }
}

/**
 * Hook to fetch user-specific vault information
 */
export const useRewardVaultUserInfo = (vaultAddress?: Address, accountAddress?: Address) => {
  const { account: connectedAccount } = useConnection()
  const account = useMemo(() => accountAddress || connectedAccount, [accountAddress, connectedAccount])
  const { data: basicInfo } = useRewardVaultBasicInfo(vaultAddress)

  const contracts = useMemo(() => {
    if (!vaultAddress || !account) return []
    return [
      {
        address: vaultAddress,
        abi: REWARD_VAULT_ABI as Abi,
        functionName: 'balanceOf',
        args: [account],
      },
      {
        address: vaultAddress,
        abi: REWARD_VAULT_ABI as Abi,
        functionName: 'getTotalDelegateStaked',
        args: [account],
      },
    ]
  }, [vaultAddress, account])

  const { data: results, isLoading: isLoadingBatch } = useReadContractMultiple({
    contracts,
    query: {
      ...REFETCH_POLICY_FAST,
      enabled: contracts.length > 0,
    },
  })

  const balanceOfResult = useMemo(() => {
    return {
      result: results?.[0]?.result !== undefined ? [results[0].result] : undefined,
      loading: isLoadingBatch,
      error: results?.[0]?.status === 'failure',
    }
  }, [results, isLoadingBatch])
  const delegateStakedResult = useMemo(() => {
    return {
      result: results?.[1]?.result !== undefined ? [results[1].result] : undefined,
      loading: isLoadingBatch,
      error: results?.[1]?.status === 'failure',
    }
  }, [results, isLoadingBatch])

  // Determine loading state
  const isLoading = useMemo(() => {
    return [balanceOfResult, delegateStakedResult].some((result) => result.loading)
  }, [balanceOfResult, delegateStakedResult])

  // Determine error state
  const hasError = useMemo(() => {
    return [balanceOfResult, delegateStakedResult].some((result) => !!result.error)
  }, [balanceOfResult, delegateStakedResult])

  // Create CurrencyAmount objects with proper error handling
  const userStakedAmount = useMemo(() => {
    if (!basicInfo?.stakeToken || balanceOfResult.error) return undefined

    try {
      const balance = balanceOfResult.result?.[0] ?? 0n
      return CurrencyAmount.fromRawAmount(basicInfo.stakeToken, balance.toString())
    } catch (e) {
      console.error('Error creating userStakedAmount:', e)
      return undefined
    }
  }, [basicInfo?.stakeToken, balanceOfResult.error, balanceOfResult.result])

  const delegateStakedAmount = useMemo(() => {
    if (!basicInfo?.stakeToken || delegateStakedResult.error) return undefined

    try {
      const delegateStaked = delegateStakedResult.result?.[0] ?? 0n
      return CurrencyAmount.fromRawAmount(basicInfo.stakeToken, delegateStaked.toString())
    } catch (e) {
      console.error('Error creating delegateStakedAmount:', e)
      return undefined
    }
  }, [basicInfo?.stakeToken, delegateStakedResult.error, delegateStakedResult.result])

  const userSelfStakedAmount = useMemo(() => {
    if (!userStakedAmount || !delegateStakedAmount || !basicInfo?.stakeToken) return undefined

    try {
      const selfStaked = userStakedAmount.subtract(delegateStakedAmount)
      return selfStaked.greaterThan('0') ? selfStaked : CurrencyAmount.fromRawAmount(basicInfo.stakeToken, '0')
    } catch (e) {
      console.error('Error creating userSelfStakedAmount:', e)
      return CurrencyAmount.fromRawAmount(basicInfo.stakeToken, '0')
    }
  }, [userStakedAmount, delegateStakedAmount, basicInfo.stakeToken])

  // Get USD value of user staked amount
  const userStakedUSD = useTokenValue(userStakedAmount)

  // Create positions array if user has staked tokens
  const positions = useMemo(() => {
    if (!userStakedAmount || userStakedAmount.equalTo('0')) return []

    return [
      {
        id: `${vaultAddress}-${account}`,
        liquidity: userStakedAmount,
        tokenId: `${vaultAddress}-position-${account}`,
      },
    ]
  }, [userStakedAmount, vaultAddress, account])

  const data = useMemo(() => {
    return {
      userStaked: userStakedAmount,
      userStakedUSD,
      selfStaked: userSelfStakedAmount,
      delegateStaked: delegateStakedAmount,
      positions,
    }
  }, [userStakedAmount, userStakedUSD, userSelfStakedAmount, delegateStakedAmount, positions])

  return {
    isLoading,
    error: hasError,
    data,
  }
}

/**
 * Hook to fetch earned rewards from a reward vault
 */
export const useRewardVaultEarned = (vaultAddress?: Address, accountAddress?: Address) => {
  const { account: connectedAccount } = useConnection()
  const account = useMemo(() => accountAddress || connectedAccount, [accountAddress, connectedAccount])
  const { data: basicInfo } = useRewardVaultBasicInfo(vaultAddress)

  const {
    data: earnedData,
    isLoading: isLoadingEarned,
    error,
  } = useReadContract({
    address: vaultAddress,
    abi: REWARD_VAULT_ABI as Abi,
    functionName: 'earned',
    args: account ? [account] : undefined,
    query: {
      enabled: !!vaultAddress && !!account,
    },
  })

  const earnedResult = useMemo(() => {
    return { result: earnedData !== undefined ? [earnedData] : undefined, loading: isLoadingEarned, error: !!error }
  }, [earnedData, isLoadingEarned, error])

  // Determine loading state
  const isLoading = useMemo(() => {
    return earnedResult.loading
  }, [earnedResult])

  // Determine error state
  const hasError = useMemo(() => {
    return !!earnedResult.error
  }, [earnedResult])

  // Create CurrencyAmount for earned rewards
  const earnedAmount = useMemo(() => {
    if (!basicInfo?.rewardToken || !earnedResult.result || earnedResult.error || !earnedResult.result[0])
      return undefined

    try {
      const earned = earnedResult.result[0]
      return CurrencyAmount.fromRawAmount(basicInfo.rewardToken, earned.toString())
    } catch (e) {
      console.error('Error creating earnedAmount:', e)
      return undefined
    }
  }, [basicInfo?.rewardToken, earnedResult])

  // Get USD value of earned amount
  const { value: earnedUSD } = useApiTokenValue(earnedAmount)

  // Return array of earned rewards for consistency with farm interface
  const earnedRewards = useMemo(() => {
    if (!earnedAmount || earnedAmount.equalTo('0')) return []
    return [earnedAmount]
  }, [earnedAmount])

  return {
    isLoading,
    error: hasError,
    earned: earnedAmount,
    earnedUSD,
    earnedRewards,
  }
}

export const useRewardVaultYearlyEmissionUSD = (vaultAddress?: Address) => {
  const { data: basicInfo } = useRewardVaultBasicInfo(vaultAddress)

  // Get native token price for fallback
  const wbera = useNativeCurrency().wrapped
  const { price: beraPrice } = useGetTokenPrice(wbera.address)

  const { data: rewardRateData, isLoading } = useReadContract({
    address: vaultAddress,
    abi: REWARD_VAULT_ABI as Abi,
    functionName: 'rewardRate',
    query: {
      enabled: !!vaultAddress,
    },
  })

  const rewardRateResult = useMemo(() => {
    return { result: rewardRateData !== undefined ? [rewardRateData] : undefined, loading: isLoading, error: false }
  }, [rewardRateData, isLoading])

  // Calculate yearly reward amount (using the actual reward token)
  const yearlyRewardAmount = useMemo(() => {
    if (!basicInfo?.rewardToken || !rewardRateResult.result || rewardRateResult.error) return undefined

    try {
      const rewardRate = rewardRateResult.result[0] as bigint
      const yearlyReward = rewardRate * BigInt(YEAR)

      return CurrencyAmount.fromRawAmount(basicInfo.rewardToken, yearlyReward.toString())
    } catch (e) {
      console.error('Error calculating yearlyRewardAmount:', e)
      return undefined
    }
  }, [basicInfo?.rewardToken, rewardRateResult])

  // First try getting USD value from subgraph
  const { value: subgraphYearlyRewardUSD } = useApiTokenValue(yearlyRewardAmount)

  // Calculate yearlyRewardUSD with comprehensive fallback logic
  const yearlyRewardUSD = useMemo(() => {
    // If subgraph has a valid value, use it
    if (subgraphYearlyRewardUSD !== null && subgraphYearlyRewardUSD > 0) {
      return subgraphYearlyRewardUSD
    }

    // If we have yearly reward amount, use BERA price as fallback
    if (yearlyRewardAmount && beraPrice && beraPrice > 0) {
      try {
        const decimals = yearlyRewardAmount.currency.decimals
        const rawAmount = yearlyRewardAmount.quotient.toString()
        const decimalValue = Number(rawAmount) / 10 ** decimals

        const fallbackValue = decimalValue * beraPrice

        return fallbackValue
      } catch (e) {
        console.error('Error calculating fallback yearlyRewardUSD with BERA price:', e)
      }
    }

    // Last resort fallback - use 1 as the price if all else fails
    if (yearlyRewardAmount) {
      try {
        const decimals = yearlyRewardAmount.currency.decimals
        const rawAmount = yearlyRewardAmount.quotient.toString()
        const decimalValue = Number(rawAmount) / 10 ** decimals

        return decimalValue
      } catch (e) {
        console.error('Error calculating last resort yearlyRewardUSD:', e)
      }
    }

    return 0
  }, [subgraphYearlyRewardUSD, yearlyRewardAmount, beraPrice])

  return {
    isLoading,
    yearlyRewardAmount,
    yearlyRewardUSD,
  }
}

/**
 * Hook to calculate APR for a reward vault
 */
export const useRewardVaultAPR = (vaultAddress?: Address) => {
  const { yearlyRewardUSD: _yearlyRewardUSD, isLoading: emissionLoading } =
    useRewardVaultYearlyEmissionUSD(vaultAddress)
  const { value: totalStakedUSD, isLoading: tvlLoading } = useRewardVaultTVL(vaultAddress)

  const yearlyRewardUSD = _yearlyRewardUSD / 1e18

  const isLoading = emissionLoading || tvlLoading

  // Calculate APR with detailed debugging
  const apr = useMemo(() => {
    if (_yearlyRewardUSD === 0) {
      return 0
    }

    if (totalStakedUSD === null || totalStakedUSD === 0) {
      return 0
    }
    const calculatedApr = (yearlyRewardUSD / totalStakedUSD) * 100

    return calculatedApr
  }, [_yearlyRewardUSD, totalStakedUSD, yearlyRewardUSD])

  return {
    isLoading,
    value: apr,
    yearlyRewardUSD,
    totalStakedUSD,
  }
}

/**
 * Combined hook that provides all reward vault data (for backward compatibility)
 */
export const useRewardVaultDatas = (vaultAddress?: Address, accountAddress?: Address, fallbackRewardPrice = 1) => {
  const basicInfo = useRewardVaultBasicInfo(vaultAddress)
  const tvlInfo = useRewardVaultTVL(vaultAddress)
  const userInfo = useRewardVaultUserInfo(vaultAddress, accountAddress)
  const earnedInfo = useRewardVaultEarned(vaultAddress, accountAddress)
  const aprInfo = useRewardVaultAPR(vaultAddress)

  // Combine loading and error states
  const isLoading = useMemo(() => {
    return basicInfo.isLoading || tvlInfo.isLoading || userInfo.isLoading || earnedInfo.isLoading || aprInfo.isLoading
  }, [basicInfo.isLoading, tvlInfo.isLoading, userInfo.isLoading, earnedInfo.isLoading, aprInfo.isLoading])

  const hasError = useMemo(() => {
    return basicInfo.error || tvlInfo.error || userInfo.error || earnedInfo.error
  }, [basicInfo.error, tvlInfo.error, userInfo.error, earnedInfo.error])

  // Combine all data into the expected format for backward compatibility
  const data = useMemo(() => {
    if (!basicInfo.data?.stakeToken) return undefined

    return {
      ...basicInfo.data,
      totalStaked: tvlInfo.totalStaked,
      totalStakedUSD: tvlInfo.value,
      ...userInfo.data,
      earned: earnedInfo.earned,
      earnedUSD: earnedInfo.earnedUSD,
    }
  }, [basicInfo.data, tvlInfo.totalStaked, tvlInfo.value, userInfo.data, earnedInfo.earned, earnedInfo.earnedUSD])

  return {
    isLoading,
    error: hasError,
    data,
    tvl: tvlInfo.value,
    apr: aprInfo.value,
    yearlyRewardUSD: aprInfo.yearlyRewardUSD,
    subgraphYearlyRewardUSD: aprInfo.yearlyRewardUSD,
  }
}
